export function LogoSmall({
  width = 50,
  heigth = 50,
  fill = "#8d8d8d",
  className,
}) {
  return (
    <svg
      className={className}
      version="1.1"
      fill={fill}
      height={50}
      width={300}
      x="0px"
      y="0px"
      viewBox="0 0 307 38"
    >
      <path
        class="st0"
        d="M 17 4.7 C 16.6 5.2 16.4 5.9 16.4 6.5 L 16.4 11.2 C 16.8 11.1 17.3 11.1 17.8 11.1 C 26.9 11.1 34.3 18.3 34.3 27.3 C 34.3 30.7 33.3 33.8 31.5 36.4 C 29.1 36.8 26.6 37.2 24 37.4 C 24.4 36.3 24.6 35.1 24.6 33.9 C 24.6 32.3 24.4 31.4 24.3 30.7 C 24.3 30.3 24.2 29.9 24.2 29.6 C 24.2 29.3 24.5 28.9 24.8 28.3 C 25.5 27.1 26.5 25.2 26.6 22.8 L 26.6 22.3 C 26.5 20.1 24.6 18.3 22.4 18.3 L 22.2 18.3 C 20.7 18.3 19.9 18.6 19.3 18.9 C 18.8 19.1 18.4 19.3 17.8 19.3 C 17.2 19.3 16.9 19.2 16.4 19 C 15.7 18.7 15 18.4 13.6 18.4 L 13.2 18.4 C 11 18.4 9.1 20.2 9.1 22.4 L 9.1 22.6 C 9.1 25.2 10.2 27.1 10.9 28.4 C 11.3 29 11.5 29.4 11.5 29.7 C 11.5 30 11.4 30.4 11.3 30.8 C 11.1 31.5 10.9 32.4 10.9 34 C 10.9 35.2 11.1 36.4 11.5 37.5 C 8.9 37.3 6.3 37 3.9 36.5 C 2.1 33.9 1 30.8 1 27.4 C 1 20 6.1 13.7 13 11.8 L 13 6.5 C 13 5.8 12.8 5.2 12.4 4.7 C 11.9 4 11.6 3.4 11.6 2.9 C 11.6 1.3 12.9 0 14.6 0 C 16.3 0 17.6 1.3 17.6 2.9 C 17.6 3.5 17.3 4.1 17 4.7 M 19.6 37.8 C 18.9 37.8 18.1 37.8 17.4 37.8 C 16.8 37.8 16.3 37.8 15.7 37.8 C 15.7 37.6 15.7 36.7 15.7 36.4 C 15.7 34.3 16.4 33.6 17.6 33.6 C 18.8 33.6 19.6 34.2 19.6 36.2 C 19.6 36.4 19.6 37.6 19.6 37.8"
      />
    </svg>
  );
}

export default function Logo({
  width = 60,
  height = 70,
  fill = "#8d8d8d",
  className,
}) {
  return (
    <svg
      className={className}
      version="1.1"
      fill={fill}
      height={height}
      width={width}
      x="0px"
      y="0px"
      viewBox="0 0 214 251"
    >
      <g fill={fill}>
        <path d="M94 40.6c-18.4 3.2-34.9 16.1-43.6 33.9-9.2 18.9-9.5 38.4-.6 42.8 3.4 1.8 16.3 5.1 26.2 6.9 10.2 1.8 47.2 1.8 56.5-.1 12-2.3 22.7-5.1 26.4-7.1 5.4-2.7 6.6-5.8 6.5-16.1-.3-16.5-6.7-31.3-18.9-43.4-14.3-14.3-33.2-20.4-52.5-16.9m18.2 15.9c7.5 1 17.9 6.7 23.8 13.2 6.4 7 8.5 11 10.3 20.3 3.3 16.4-.1 19.5-23.5 21.9-17.1 1.7-44.6-1.6-56.2-6.8-6.2-2.7-7.6-7.2-5.2-16.7 2.8-11.4 9.9-21 19.9-26.9 6.8-3.9 17.5-6.6 23.7-5.9 1.4.2 4.6.6 7.2.9" />
        <path d="M79.5 79.9c-2.8 1.2-5.4 4.4-6.4 7.7-1.1 3.9-.4 5.4 2.3 5.4 1.7 0 2.5-.8 3.2-3.3.6-1.9 2-3.7 3.7-4.5 3.8-1.8 7.8.2 9.1 4.5.7 2.5 1.4 3.3 3.2 3.3 2.1 0 2.4-.5 2.4-3.5 0-5.5-4.3-9.7-10.6-10.1-2.7-.2-5.8 0-6.9.5M118.4 80c-3.4 1.3-6.4 5.9-6.4 9.6 0 2.9.3 3.4 2.4 3.4 1.8 0 2.5-.8 3.2-3.3.6-1.9 2-3.7 3.7-4.5 3.8-1.8 7.8.2 9.1 4.5.7 2.5 1.5 3.3 3.1 3.3 3 0 3.8-2.4 2.1-6.4-2.7-6.5-10.3-9.4-17.2-6.6M48.3 126.1c-.8.8-.2 3.6 2.4 10.8 1.9 5.3 7.5 21.7 12.4 36.6C72.6 201.9 75 207 82.6 214c10.6 9.8 23.4 12 35.8 6.2 12.9-6 19.1-15.3 26.7-40.2 2.2-7.4 7.3-22.4 11.1-33.3 4.1-11.4 6.7-20.2 6.2-20.6-.5-.5-5.2.2-10.4 1.5-29.3 7.2-63 7.4-91.5.5-4.4-1.1-8.7-2.2-9.5-2.6-.9-.3-2.1 0-2.7.6M35.7 131.8c-2.8 3.2-4.1 9.7-4.1 20.2 0 13.1 1.5 20.3 6.4 30.5 4.4 9.2 10.3 16.4 16.5 20 6.6 3.9 9.3 1.6 8-7.1-.3-2.4-4.7-16.2-9.6-30.6-11.2-32.6-13.6-37.1-17.2-33M170.2 132.3c-2.6 2.8-4.3 7.2-14 36.3-10.5 31.2-11.1 35.4-5.6 35.4 9 0 21.2-15.6 26-33 2.5-9.2 2.6-28.7.1-35.2-2.1-5.5-3.8-6.4-6.5-3.5" />
      </g>
    </svg>
  );
}
